<div
  [formGroup]="form"
  class="textarea-container flex flex-column gap-2"
  [ngClass]="{ invalid: isInValid }"
>
  <label *ngIf="hasLabel" [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <div class="relative flex">
    <textarea
      rows="4"
      ngClass="w-full"
      pInputTextarea
      [placeholder]="item.placeholder || '' | translate"
      [maxlength]="item.config?.maxLength || maxLength"
      [formControlName]="item.key"
    ></textarea>

    <div class="absolute count" *ngIf="maxLength > 0">
      ({{ currentLength }}/{{ item.config?.maxLength || maxLength }} characters)
    </div>
  </div>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
